import { createFileRoute } from "@tanstack/react-router";
import { ListingsPage } from "@/app/connect/pages/listings";

type ListingsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/listings")({
	validateSearch: (search: Record<string, unknown>): ListingsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: ListingsPage,
});
